import React, { useEffect } from 'react';

import { ChangelogDiffType } from '@/features/changelog/constants';
import VariableContextProvider, {
  useVariableDispatchContext,
} from '@/features/variable/contexts/variable-context';
import VariableDetail from '@/features/variable/settings/detail';
import Validation from '@/features/variable/settings/validation';
import { setVariableDiff } from '@/features/variable/store/actions/variable/action-creators';
import { VariableInfo } from '@/lib/PlannerDTOs';

interface VariableDiffWrapperProps {
  diffType: ChangelogDiffType;
  previousVariable: VariableInfo;
  currentVariable: VariableInfo;
  style?: React.CSSProperties;
}

const Content = ({
  diffType,
  previousVariable,
  currentVariable,
  style,
}: VariableDiffWrapperProps) => {
  const variableDispatch = useVariableDispatchContext();

  useEffect(() => {
    variableDispatch(setVariableDiff(previousVariable, currentVariable));
  }, []);

  return (
    <div
      className={`changelog-item-${diffType === ChangelogDiffType.BEFORE ? 'old' : 'new'}-variable-container`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        ...style,
      }}
    >
      <VariableDetail />
      <Validation />
    </div>
  );
};

const VariableDiffWrapper = ({ ...props }: VariableDiffWrapperProps) => {
  return (
    <VariableContextProvider>
      <Content {...props} />
    </VariableContextProvider>
  );
};

export default VariableDiffWrapper;
